/*
 * Copyright 2019 FedEx
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Components
import { CommonReasonCodeComponent } from './components/common-reason-code/common-reason-code.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';

const appRoutes: Routes = [
  {path: 'confirmation', component: ConfirmationComponent},
  {path: 'commonReasonCode/termsAndConditions/:countryCode/:languageCode', component: TermsAndConditionsComponent},
  {path: 'commonReasonCode/:uniqueId', component: CommonReasonCodeComponent},
  {path: '', component: CommonReasonCodeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
